module.exports = __webpack_public_path__ + "media/images/indicators/diasSemChuva-720b9140fd328d3b0b5bf63a76ecc312.png";